import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export const QuoteSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { trackingNumber, email } = location.state || {};

  useEffect(() => {
    if (!trackingNumber) {
      navigate('/');
    }
  }, [trackingNumber, navigate]);

  if (!trackingNumber) return null;

  return (
    <div className="max-w-4xl mx-auto p-6 text-center">
      <div className="rounded-lg border border-border bg-card text-card-foreground shadow-sm p-12">
        <div className="mb-6 flex justify-center">
          <div className="h-24 w-24 rounded-full bg-green-100 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
        </div>

        <h2 className="text-3xl tracking-tight text-foreground mb-4">
          {t('quote.success_page.title')}
        </h2>

        <p className="text-lg text-muted-foreground mb-8">
          {t('quote.success_page.message')}
        </p>

        <div className="bg-muted p-6 rounded-md inline-block mb-8 border border-border">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-1">
            {t('quote.success_page.tracking_code')}
          </p>
          <p className="text-3xl font-mono text-foreground tracking-wider">
            {trackingNumber}
          </p>
        </div>

        <p className="text-muted-foreground mb-8 max-w-lg mx-auto">
          {t('quote.success_page.email_sent', { email })}
        </p>

        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-11 px-8"
        >
          {t('quote.success_page.button')}
        </button>
      </div>
    </div>
  );
};
